module.exports = __webpack_public_path__ + "28220773f33de963a72580deaae6a331.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/ALLEYESONUS2.jpg
// module id = 456
// module chunks = 0